import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'notes.button.show': {
    id: 'notes.button.show',
    defaultMessage: 'Show Notes',
    description: 'Message for toggling notes visibility',
  },
  'notes.button.hide': {
    id: 'notes.button.hide',
    defaultMessage: 'Hide Notes',
    description: 'Message for toggling notes visibility',
  },
});

export default messages;
